/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  AdsFeedControllerGetGoogleAdsPagesExtendedFeedQueryResponse,
  AdsFeedControllerGetGoogleAdsPagesExtendedFeedPathParams,
} from '../types/AdsFeedControllerGetGoogleAdsPagesExtendedFeed.ts';

function getAdsFeedGetGoogleAdsPagesExtendedFeedUrl(
  wlDomain: AdsFeedControllerGetGoogleAdsPagesExtendedFeedPathParams['wlDomain'],
) {
  const res = { method: 'GET', url: `/api/ads-feed/${wlDomain}/google-ads-pages-extended.csv` as const };
  return res;
}

/**
 * {@link /api/ads-feed/:wlDomain/google-ads-pages-extended.csv}
 */
export async function adsFeedGetGoogleAdsPagesExtendedFeed(
  wlDomain: AdsFeedControllerGetGoogleAdsPagesExtendedFeedPathParams['wlDomain'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    AdsFeedControllerGetGoogleAdsPagesExtendedFeedQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: getAdsFeedGetGoogleAdsPagesExtendedFeedUrl(wlDomain).url.toString(), ...requestConfig });
  return res.data;
}
